import React from "react";
import { useTranslation } from "react-i18next";

function TeacherIntro() {
    const { t } = useTranslation();

    return (
        <section className="teacherIntro">
            <div className="inner-wrapper">
                <h2>
                    {/* {t("teacherIntro.IntroTitle")} */}
                    {t("teacherIntro.IntroDesc2")}
                </h2>
                {/* <p>{t("teacherIntro.IntroDesc1")}</p> */}
                <p>{t("teacherIntro.IntroDesc3")}</p>
                <p>{t("teacherIntro.IntroDesc4")}</p>
                <p>{t("teacherIntro.IntroDesc5")}</p>
            </div>
        </section>
    );
}

export default TeacherIntro;
